import { ACTION_TYPES } from './action';
import { LOCALE } from './locale';

// isProduction: 현재 개발환경이 아닌 경우, 즉 실제 서버에 추가할 경우 true
const IS_PRODUCTION =
  process.env.NODE_ENV === 'production' &&
  process.env.REACT_APP_PRODUCT_MODE !== 'TEST';

export { ACTION_TYPES, LOCALE, IS_PRODUCTION };
